import { gql } from '@apollo/client'

const imDfmFeedbackQuery = gql`
    query imDfmFeedback($qmrId: UUID!) {
        quoteModelRevision(id: $qmrId) {
            id
            dfmFeedback(includeDraft: true) {
                id
                createdAt
                isPublished
                message
                sourceType
                status
                updatedAt
                isAutoGeneratedDfm
                updatedBy {
                    id
                    email
                }
                topic {
                    id
                    label
                }
                title
                attachment {
                    id
                    fileName
                    downloadUrl
                }
                acceptedBy {
                    id
                    email
                }
            }
        }
    }
`

export default imDfmFeedbackQuery
